/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */

export type EnumPreventivoDTOStato =
  (typeof EnumPreventivoDTOStato)[keyof typeof EnumPreventivoDTOStato];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumPreventivoDTOStato = {
  ATTESA_APPROVAZIONE: 'ATTESA_APPROVAZIONE',
  ATTESA_PAGAMENTO: 'ATTESA_PAGAMENTO',
  PAGATO: 'PAGATO',
  RIFIUTATO: 'RIFIUTATO',
} as const;
